import { Component, computed, input } from '@angular/core';
import { Color } from '../../../models/enums';

@Component({
  selector: 'app-highlight-beam-icon',
  imports: [],
  templateUrl: './highlight-beam-icon.component.html'
})
export class HighlightBeamIconComponent {
  highlightColor = input.required<Color>();

  beamColor = computed(() =>
    this.highlightColor() === Color.Brown ? '#6f2f00' : this.highlightColor()
  );

  beamTextShadow = computed(() => {
    const hc = this.highlightColor();
    if (hc === Color.Brown) {
      return '#d53900fa 0px -2px 1px, rgb(14, 14, 14) 0px -4px 1px, #c78100 0px 0px 3px';
    }
    return `0px -2px 1px ${hc}, #0e0e0e 0px -4px 1px, white 0px 0px 3px`;
  });
}
